import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import ImageWithSkeleton from "../component/ImageWithSkeleton";
import { motion } from "framer-motion";
import ScrollFloat from "../component/ScrollFloat";
import { Helmet } from "react-helmet";

export default function Metaversedevelopment() {
  const coinImages = [
    "assets/images/coin/coin_01.png",
    "assets/images/coin/coin_02.png",
    "assets/images/coin/coin_03.png",
    "assets/images/coin/coin_04.png",
    "assets/images/coin/coin_05.png",
    "assets/images/coin/coin_06.png",
    "assets/images/coin/coin_07.png",
    "assets/images/coin/coin_08.png",
    "assets/images/coin/coin_09.png",
    "assets/images/coin/coin_10.png",
    "assets/images/coin/coin_11.png",
    "assets/images/coin/coin_12.png",
  ];

  const industries = [
    {
      title: "Healthcare",
      icon: "assets/images/blockchain/healthcare.svg",
    },
    {
      title: "Real Estate",
      icon: "assets/images/blockchain/RealEstate.svg",
    },
    {
      title: "BFSI",
      icon: "assets/images/blockchain/Banking.svg",
    },
    {
      title: "Logistics",
      icon: "assets/images/blockchain/Logistics.svg",
    },
    {
      title: "Retail",
      icon: "assets/images/blockchain/Retail.svg",
    },
    {
      title: "Entertainment",
      icon: "assets/images/blockchain/Entertainment.webp",
    },
    {
      title: "Education",
      icon: "assets/images/blockchain/Education.svg",
    },
    {
      title: "Energy",
      icon: "assets/images/blockchain/Energy.webp",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleItem = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // light dark change image

  const [theme, setTheme] = useState("light");

  useEffect(() => {
    const currentTheme =
      document.documentElement.getAttribute("data-theme") || "light";
    setTheme(currentTheme);

    const observer = new MutationObserver(() => {
      const newTheme =
        document.documentElement.getAttribute("data-theme") || "light";
      setTheme(newTheme);
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => observer.disconnect();
  }, []);

  const splitTextToSpans = (text, className = "") =>
    [...text].map((char, index) => (
      <span className={`char ${className}`} key={`${char}-${index}`}>
        {char === " " ? "\u00A0" : char}
      </span>
    ));

  return (
    <>
      <Helmet>
        <title>
          Metaverse Development Services | Build Virtual Worlds | Blockcryp
        </title>
        <meta
          name="description"
          content=" Create immersive virtual experiences with Blockcryp’s metaverse development services. We build 3D worlds, avatars, NFT integration, and Web3 metaverse platforms."
        />
        <meta
          name="keywords"
          content="metaverse development services, custom metaverse solutions, virtual world development, Web3 metaverse platforms, 3D metaverse development, NFT integration in metaverse, avatar development services, metaverse app development, blockchain-based metaverse, immersive virtual experience development"
        />
      </Helmet>
      {/* ---------- hreo section start ---------- */}
      <section className="token_hero overflow-hidden space80">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 order-lg-1 order-2">
              <motion.h1
                className="heading_h1 fw-bold"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                Metaverse Development Company
              </motion.h1>
              <motion.p
                className="pera_txt"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                Step into the future with <b>Metaverse Development Services</b>{" "}
                that turn imagination into immersive reality. As digital
                boundaries blur, businesses need virtual ecosystems to engage,
                monetize, and innovate. At Blockcryp, we build custom,
                blockchain-powered <b>Metaverse Software Development </b>{" "}
                tailored for real-world impact. From virtual storefronts to NFT
                marketplaces, we craft scalable, interactive environments that
                elevate user experience and drive growth. Partner with the best,
                partner with Blockcryp.
              </motion.p>

              {/* <button class="button theme_btn mt-lg-4 mt-0" type="submit">
                Talk to Our Expert
              </button> */}
            </div>
            <div className="col-lg-6 order-lg-2 order-1">
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <ImageWithSkeleton
                  src="assets/images/metaverse/metaverse_hero2.webp"
                  alt="token hero"
                  className="w-100"
                />
                {/* <img
                  src="assets/images/metaverse/metaverse_hero.webp"
                  alt="token hero"
                  className="w-100"
                /> */}
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* --------- -- about section start -------- */}
      <div className="space80 overflow-hidden">
        <div className="container">
          <div className="row justify-content-center mb-4 mb-lg-5">
            <div className="col-12">
              <ScrollFloat
                animationDuration={1}
                ease="back.inOut(2)"
                scrollStart="center bottom+=50%"
                scrollEnd="bottom bottom-=40%"
                stagger={0.09}
                textClassName="heading_h3 fw-semibold text-center"
              >
                <>
                  {splitTextToSpans(" The Unique Features of Our Metaverse ")}{" "}
                  <br className="d-md-block d-none" />
                  {splitTextToSpans(" Development Solutions", "text-primary")}
                </>
              </ScrollFloat>
              <motion.p
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="pera_txt text-center"
              >
                Blockcryp Metaverse development goes beyond expectations,
                delivering immersive, feature-rich experiences{" "}
                <br className="d-none d-lg-block"></br> that set you apart. Our
                expert developers provide the tools to fully realize your vision
              </motion.p>
            </div>
          </div>
          <div className="row align-items-center g-4">
            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="about_card meta_card"
              >
                <img
                  src="assets/images/metaverse/Virtual-Marketplaces.png"
                  alt=""
                  className="mb-4"
                />
                <h3 className="text-start heading_h5 mb-3 fw-bold">
                  Virtual Marketplaces
                </h3>
                <div>
                  <p className="mb-0">
                    Discover, trade, and own a diverse array of digital assets,
                    collectibles, and unique items that hold real value for
                    ownership. Build credibility and trust lacking in the
                    traditional market.
                  </p>
                </div>
              </motion.div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="about_card meta_card"
              >
                <img
                  src="assets/images/metaverse/Gamified-Experience.png"
                  alt=""
                  className="mb-4"
                />
                <h3 className="text-start heading_h5 mb-3 fw-bold">
                  Gamified Experience
                </h3>
                <div>
                  <p className=" mb-0">
                    Play, interact, unlock rewards, and transform everyday tasks
                    into epic adventures that turn learning and productivity
                    into thrilling quests.
                  </p>
                </div>
              </motion.div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="about_card meta_card"
              >
                <img
                  src="assets/images/metaverse/Multiplayer-Support.png"
                  alt=""
                  className="mb-4"
                />
                <h3 className="text-start heading_h5 fw-bold">
                  Multiplayer Support
                </h3>
                <div>
                  <p className=" mb-0">
                    Leverage cross-platform compatibility for unforgettable
                    gaming experiences while supporting sustainability
                    initiatives that reduce electronic waste.
                  </p>
                </div>
              </motion.div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="about_card meta_card"
              >
                <img
                  src="assets/images/metaverse/Communication-Tools.png"
                  alt=""
                  className="mb-4"
                />

                <h3 className="text-start heading_h5 fw-bold">
                  Communication Tools
                </h3>
                <div>
                  <p className="mb-0">
                    Enhance remote interactions with Blockcryp and customizable
                    avatars, blending text, voice, and immersive experiences for
                    richer idea exchanges.
                  </p>
                </div>
              </motion.div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="about_card meta_card"
              >
                <img
                  src="assets/images/metaverse/Intuitive-Navigation.png"
                  alt=""
                  className="mb-4"
                />

                <h3 className="text-start heading_h5 fw-bold">
                  Intuitive Navigation
                </h3>
                <div>
                  <p className="mb-0">
                    Eliminate loading time and instantly travel between distant
                    metaverse locations with AI-powered navigations, creating a
                    fluid, immersive experience.
                  </p>
                </div>
              </motion.div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="about_card meta_card"
              >
                <img
                  src="assets/images/metaverse/Dynamic-Login-Options.png"
                  alt=""
                  className="mb-4"
                />

                <h3 className="text-start heading_h5 fw-bold">
                  Dynamic Login Options
                </h3>
                <div>
                  <p className="mb-0">
                    Switch between biometric, passwordless, and multi-factor
                    authentication methods, ensuring a secure and tailored login
                    experience that adapts to your needs.
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
      {/* --------- -- about section end -------- */}

      {/* ---------- How to Get Started start ---------- */}
      <section className="space80 overflow-hidden">
        <div className="container">
          <div className="row align-items-center mb-4 mb-lg-5">
            <div className="col-12">
              <motion.p
                className="text_16 text-primary text-center"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                Getting Started with Our Metaverse Company
              </motion.p>
              <motion.h2
                className="heading_h3 fw-bold mb-4 text-center"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <span className="text-primary"> How to Get Started </span>with
                Our Metaverse
                <br className="d-none d-md-block"></br>
                Development Company
              </motion.h2>
            </div>
          </div>
          <div className="row g-4">
            <div className="col-lg-6">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <ImageWithSkeleton
                  src="assets/images/metaverse/company2.webp"
                  alt=""
                  className="w-100 pe-5"
                />
              </motion.div>
            </div>
            <div className="col-12 col-lg-6 col-xl-6">
              <div className="row justify-content-center">
                <div className="col-md-6 col-12">
                  <motion.div
                    className="how_card position-relative"
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                  >
                    <h5 className="fw-semibold mb-3">Contact Us</h5>
                    <p className="mb-0 text-secondary text_14">
                      Start your journey by filling out our contact form. Our
                      team will connect with you promptly to understand your
                      initial requirements.
                    </p>
                  </motion.div>
                </div>
                <div className="col-md-6 col-12">
                  <motion.div
                    className="how_card position-relative"
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                  >
                    <motion.h5
                      className="fw-semibold mb-3"
                      initial={{ opacity: 0, x: 50 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      transition={{ duration: 1, delay: 0.5 }}
                      viewport={{ once: false, amount: 0.5 }}
                    >
                      Get Metaverse Consulting
                    </motion.h5>
                    <motion.p
                      className="mb-0 text-secondary text_14"
                      initial={{ opacity: 0, x: 50 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      transition={{ duration: 1, delay: 0.5 }}
                      viewport={{ once: false, amount: 0.5 }}
                    >
                      Once we receive your details, we conduct a thorough
                      requirement analysis and offer expert consultation
                      tailored to your metaverse goals.
                    </motion.p>
                  </motion.div>
                </div>
                <div className="col-md-6 col-12">
                  <motion.div
                    className="how_card position-relative"
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                  >
                    <h5 className="fw-semibold mb-3">
                      Cost & Time Estimations
                    </h5>
                    <p className="mb-0 text-secondary text_14">
                      Following our discovery call, we provide a detailed
                      project proposal outlining the estimated timeline, budget,
                      and technical approach.
                    </p>
                  </motion.div>
                </div>
                <div className="col-md-6 col-12">
                  <motion.div
                    className="how_card position-relative "
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                  >
                    <h5 className="fw-semibold mb-3">Finalize Contract</h5>
                    <p className="mb-0 text-secondary text_14">
                      Upon agreement, we formalize the commitments with a signed
                      contract, ensuring transparency, alignment, and a clear
                      development roadmap.
                    </p>
                  </motion.div>
                </div>
                <div className="col-md-6 col-12">
                  <motion.div
                    className="how_card position-relative"
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                  >
                    <h5 className="fw-semibold mb-3">Kick-Off Project</h5>
                    <p className="mb-0 text-secondary text_14">
                      We assign dedicated resources, set milestones, and
                      initiate the development process, bringing your metaverse
                      vision to life.{" "}
                    </p>
                  </motion.div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ---------- How to Get Started end ---------- */}

      {/* -------------- services section start ---------*/}

      <section className="meta_services space40">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-lg-6 col-xl-6">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <ImageWithSkeleton
                  src="assets/images/metaverse/meta_services2.webp"
                  alt=""
                  className="w-100 pe-0 pe-lg-5"
                />
              </motion.div>
              {/* <motion.img
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                src="assets/images/metaverse/meta_services.webp" alt="" className="w-100 pe-0 pe-lg-5" /> */}
            </div>
            <div className="col-lg-6 col-xl-6">
              <motion.div
                className="mb-5"
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <h2 className="heading_h3 fw-bold mb-4 text-center text-xl-start">
                  Our High-End Metaverse Development
                  <span className="text-primary"> Services </span>
                  <br className="d-none d-md-block"></br>
                </h2>
              </motion.div>

              <div className="row align-items-center">
                <div className="col-lg-6 col-md-6">
                  <motion.ul
                    className="safety-list"
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                  >
                    <li>
                      <i class="bi bi-check-circle-fill me-2"></i> Metaverse
                      Integration Services
                    </li>
                    <li>
                      <i class="bi bi-check-circle-fill me-2"></i> Metaverse
                      Gaming Solutions
                    </li>
                    <li>
                      <i class="bi bi-check-circle-fill me-2"></i>Metaverse 3D
                      Space Development
                    </li>
                  </motion.ul>
                </div>
                <div className="col-lg-6 col-md-6">
                  <motion.ul
                    className="safety-list"
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                  >
                    <li>
                      <i className="bi bi-check-circle-fill me-2"></i> Metaverse
                      Social Platform
                    </li>
                    <li>
                      <i className="bi bi-check-circle-fill me-2"></i> Metaverse
                      Payment Solution
                    </li>
                    <li>
                      <i className="bi bi-check-circle-fill me-2"></i> Metaverse
                      Token Development
                    </li>
                  </motion.ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* -------------- services section end ---------*/}

      {/* ---------- faq section start ---------- */}
      <section className="space40">
        <div className="container">
          <h2 className="heading_h3 fw-bold mb-4">
            Frequently Asked Questions
          </h2>
          <div className="row">
            <div className="col-12">
              <div className="accordion">
                <div
                  className={`accordion__item ${
                    activeIndex === 0 ? "accordion__item--active" : ""
                  }`}
                >
                  <button
                    className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0"
                    onClick={() => toggleItem(0)}
                  >
                    <span className="text_20 pe-4">
                      1. What is a metaverse wallet?
                    </span>
                    <span className="accordion__icon">
                      <i className="fa fa-plus" />
                    </span>
                  </button>
                  <div className="accordion__content">
                    <p className="p-2">
                      A metaverse wallet stores digital assets like NFTs and
                      tokens, enabling users to buy, sell, and interact within
                      metaverse platforms securely using blockchain-based
                      authentication and smart contracts.
                    </p>
                  </div>
                </div>
                <div
                  className={`accordion__item ${
                    activeIndex === 1 ? "accordion__item--active" : ""
                  }`}
                >
                  <button
                    className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0"
                    onClick={() => toggleItem(1)}
                  >
                    <span className="text_20 pe-4">
                      2. What is the role of NFTs in the metaverse?
                    </span>
                    <span className="accordion__icon">
                      <i className="fa fa-plus" />
                    </span>
                  </button>
                  <div className="accordion__content">
                    <p className="p-2">
                      NFTs are unique digital assets like art, collectibles, or
                      property in the metaverse, proving ownership, enabling
                      secure trading, and supporting virtual economies on
                      blockchain networks.
                    </p>
                  </div>
                </div>
                <div
                  className={`accordion__item ${
                    activeIndex === 2 ? "accordion__item--active" : ""
                  }`}
                >
                  <button
                    className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0"
                    onClick={() => toggleItem(2)}
                  >
                    <span className="text_20 pe-4">
                      3. What are decentralized metaverse platforms?
                    </span>
                    <span className="accordion__icon">
                      <i className="fa fa-plus" />
                    </span>
                  </button>
                  <div className="accordion__content">
                    <p className="p-2">
                      Decentralized platforms like Decentraland and The Sandbox
                      run on blockchain, offering community governance,
                      user-owned assets, and open development through
                      decentralized autonomous organizations (DAOs).
                    </p>
                  </div>
                </div>
                <div
                  className={`accordion__item ${
                    activeIndex === 3 ? "accordion__item--active" : ""
                  }`}
                >
                  <button
                    className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0"
                    onClick={() => toggleItem(3)}
                  >
                    <span className="text_20 pe-4">
                      4. How does blockchain enhance the metaverse?
                    </span>
                    <span className="accordion__icon">
                      <i className="fa fa-plus" />
                    </span>
                  </button>
                  <div className="accordion__content">
                    <p className="p-2">
                      Blockchain secures digital asset ownership, enables
                      transparent transactions, supports decentralized
                      governance, and prevents fraud within the metaverse’s
                      virtual economies and communities.
                    </p>
                  </div>
                </div>
                <div
                  className={`accordion__item ${
                    activeIndex === 4 ? "accordion__item--active" : ""
                  }`}
                >
                  <button
                    className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0 "
                    onClick={() => toggleItem(4)}
                  >
                    <span className="text_20 pe-4">
                      5. Can existing businesses create their own metaverse?
                    </span>
                    <span className="accordion__icon">
                      <i className="fa fa-plus" />
                    </span>
                  </button>
                  <div className="accordion__content">
                    <p className="p-2">
                      Yes, businesses can develop branded virtual spaces for
                      marketing, training, customer engagement, or e-commerce
                      using metaverse development tools and partnerships with
                      service providers.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --------------- cta start  ------------- */}
      <div className="cta space80">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 ">
              <div className="text-center">
                <motion.h2
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="text_70 mb-3 text-uppercase fw-semibold talk_heading text-primary"
                >
                  Tell Us Your New Ideas
                </motion.h2>
                <motion.p
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="pera_txt"
                >
                  a dynamic design excelling in transforming imaginative
                  concepts into vivid realities through{" "}
                  <br className="d-none d-lg-block"></br> innovative strategies
                  and compelling creative executions.
                </motion.p>

                <a
                  href="https://teams.live.com/l/invite/FEAgoDJPJi4z_OT7QI"
                  target="_blank"
                >
                  <motion.button
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    type="button"
                    className="button talk_btn home_btn theme_btn mt-3"
                  >
                    let's talk <i class="fa-solid fa-square-up-right ms-2"></i>
                  </motion.button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* --------------- cta end  ------------- */}
    </>
  );
}
